<template>
  <div class="form-group">
    <label for="product-select">Selecione uma substância/patógeno:</label>
    <div class="dropdown">
      <button
        class="btn btn-outline-secondary dropdown-toggle w-100 text-left"
        type="button"
        @click="toggleDropdown"
      >
        {{ selectedProductDetails ? selectedProductDetails.descricao : "Selecione" }}
      </button>
      <div class="dropdown-menu w-100 p-2" :class="{ show: isOpen }">
        <input
          v-if="isOpen"
          ref="searchInput"
          v-model="searchQuery"
          type="text"
          class="form-control mb-2"
          placeholder="Pesquisar substância..."
          @click.stop
          @keydown.esc="closeDropdown"
          @keydown.enter="selectFirstFiltered"
        >
        <div class="options-container">
          <a
            v-for="product in filteredProducts"
            :key="product.id"
            class="dropdown-item"
            href="#"
            @click.prevent="selectProduct(product)"
          >
            {{ product.descricao }}
          </a>
          <div v-if="filteredProducts.length === 0" class="dropdown-item text-muted">
            Nenhuma substância encontrado
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    products: Array, // Lista de substâncias recebida como prop
  },
  data() {
    return {
      isOpen: false,
      selectedProductDetails: null,
      searchQuery: "",
    };
  },
  computed: {
    filteredProducts() {
      if (!this.products || this.products.length === 0) return [];
      if (!this.searchQuery) return this.products;

      const query = this.searchQuery.toLowerCase();
      return this.products.filter((product) =>
        product.descricao.toLowerCase().includes(query) ||
        (product.numero_un ? product.numero_un.toLowerCase().includes(query) : false)
      );
    },
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      this.searchQuery = "";
      if (this.isOpen) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    },
    closeDropdown() {
      this.isOpen = false;
      this.searchQuery = "";
    },
    async selectProduct(product) {
      // Exibe o substância diretamente no botão
      this.selectedProductDetails = product;
      this.isOpen = false;
      this.searchQuery = "";
      this.$emit("selected", this.selectedProductDetails);

      try {
        const response = await axios.get(`/api/product/${product.id}`);
        if (response.data.success) {
          this.selectedProductDetails = response.data.data;
        } else {
          console.warn("Erro na resposta da API:", response.data.message);
        }
        this.$emit("selected", this.selectedProductDetails);
      } catch (error) {
        console.error("Erro ao buscar detalhes da substância:", error);
      }
    },
    selectFirstFiltered() {
      if (this.filteredProducts.length > 0) {
        this.selectProduct(this.filteredProducts[0]);
      }
    },
    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.closeDropdown();
      }
    },
  },
  watch: {
    products() {
      this.selectedProductDetails = null;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>

<style scoped>
.dropdown-menu {
  max-height: 300px;
  /*overflow-y: auto; */
  overflow-y: hidden;
  padding: 0.5rem;
}

.options-container {
  max-height: 250px;
  overflow-y: auto;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}

.form-control:focus {
  box-shadow: none;
  border-color: #007bff;
}
</style>
